import { render } from "./CardContacto.vue?vue&type=template&id=b015ce84&scoped=true"
import script from "./CardContacto.vue?vue&type=script&lang=js"
export * from "./CardContacto.vue?vue&type=script&lang=js"

import "./CardContacto.vue?vue&type=style&index=0&id=b015ce84&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b015ce84"]])

export default __exports__